// extracted by mini-css-extract-plugin
module.exports = {"timeline":"Timeline_timeline__1C5vH","container":"Timeline_container__k87qw","detail":"Timeline_detail__Lhxly","info":"Timeline_info__fqkx4"};